import { usePageRefreshKey } from '../../../../context/PageRefreshContext';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { listShareCertificates } from '../../../../redux/actions/SocietyPortal/ShareCertificateAction/ShareCertificateAction';
import { selectedSocietyStorer } from '../../../../utils/webStorer';
import {
    SOCIETY_PORTAL,
    SOCIETY_PORTAL_SHARE_CERTIFICATE_DETAIL
} from '../../../../Routing/routes';

const STATUSES = [
    { value: '', label: 'All Statuses' },
    { value: 'ACTIVE', label: 'Active' },
    { value: 'LIEN_MARKED', label: 'Lien Marked' },
    { value: 'SURRENDERED', label: 'Surrendered' },
    { value: 'CANCELLED', label: 'Cancelled' }
];

const statusColor = (s) => {
    switch (s) {
        case 'ACTIVE': return 'tw-bg-emerald-100 tw-text-emerald-700';
        case 'LIEN_MARKED': return 'tw-bg-amber-100 tw-text-amber-700';
        case 'SURRENDERED': return 'tw-bg-gray-100 tw-text-gray-700';
        case 'CANCELLED': return 'tw-bg-red-100 tw-text-red-700';
        default: return 'tw-bg-gray-100 tw-text-gray-700';
    }
};

const ShareCertificates = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const societyId = selectedSocietyStorer.getSocietyId();

    const { list } = useSelector(state => state.ShareCertificateReducer);
    const [status, setStatus] = useState('');
    const [page, setPage] = useState(1);
    const limit = 10;

    const refreshKey = usePageRefreshKey();
    useEffect(() => {
        if (societyId) {
            dispatch(listShareCertificates({
                societyId,
                page,
                limit,
                status: status || undefined
            }));
        }
    }, [dispatch, societyId, page, status, refreshKey]);

    const rows = list?.rows || [];
    const pagination = list?.pagination;

    const goToDetail = (id) => {
        const path = SOCIETY_PORTAL_SHARE_CERTIFICATE_DETAIL.replace(':id', id);
        navigate(`${SOCIETY_PORTAL}${path}`);
    };

    return (
        <div className="tw-space-y-4">
            <div className="tw-flex tw-items-center tw-justify-between">
                <div>
                    <h1 className="tw-text-lg tw-font-semibold tw-text-gray-800">Share Certificates</h1>
                    <p className="tw-text-xs tw-text-gray-500">Society-wide share certificate register</p>
                </div>
            </div>

            <div className="tw-bg-white tw-rounded-lg tw-py-2.5 tw-px-3 tw-shadow-sm tw-border tw-border-gray-100 tw-flex tw-items-center tw-gap-3">
                <select
                    value={status}
                    onChange={(e) => { setStatus(e.target.value); setPage(1); }}
                    className="tw-px-2.5 tw-py-1.5 tw-border tw-border-gray-200 tw-rounded-md tw-text-sm tw-bg-white"
                >
                    {STATUSES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                </select>
                <span className="tw-text-xs tw-text-gray-400 tw-ml-auto">
                    Showing {rows.length} of {pagination?.totalItems || rows.length}
                </span>
            </div>

            <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-100 tw-overflow-hidden">
                {list?.loading ? (
                    <div className="tw-py-10 tw-flex tw-justify-center">
                        <div className="tw-animate-spin tw-rounded-full tw-h-7 tw-w-7 tw-border-b-2 tw-border-blue-600" />
                    </div>
                ) : rows.length === 0 ? (
                    <div className="tw-py-10 tw-text-center">
                        <Icon icon="mdi:certificate-outline" className="tw-text-3xl tw-text-gray-300" />
                        <p className="tw-text-sm tw-text-gray-500 tw-mt-2">No certificates found.</p>
                    </div>
                ) : (
                    <table className="tw-w-full tw-text-sm">
                        <thead>
                            <tr className="tw-bg-gray-50 tw-border-b tw-border-gray-100">
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Cert #</th>
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Flat</th>
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Holder</th>
                                <th className="tw-text-right tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Shares</th>
                                <th className="tw-text-right tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Value</th>
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Issued</th>
                                <th className="tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Status</th>
                                <th className="tw-text-center tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map(row => (
                                <tr key={row.share_certificate_id || row.id} className="tw-border-b tw-border-gray-50 hover:tw-bg-gray-50">
                                    <td className="tw-px-3 tw-py-2 tw-text-gray-700">{row.certificate_number}</td>
                                    <td className="tw-px-3 tw-py-2 tw-text-gray-700">
                                        {row.flat ? `${row.flat?.wing?.title || ''} ${row.flat?.flat_number || ''}`.trim() : '—'}
                                    </td>
                                    <td className="tw-px-3 tw-py-2 tw-text-gray-700">
                                        {row.entity?.name || row.entity?.first_name || '—'}
                                    </td>
                                    <td className="tw-px-3 tw-py-2 tw-text-right tw-text-gray-700">{row.total_shares}</td>
                                    <td className="tw-px-3 tw-py-2 tw-text-right tw-text-gray-700">
                                        ₹{Number(row.total_value || 0).toLocaleString('en-IN')}
                                    </td>
                                    <td className="tw-px-3 tw-py-2 tw-text-gray-700">{row.issued_date}</td>
                                    <td className="tw-px-3 tw-py-2">
                                        <span className={`tw-px-2 tw-py-0.5 tw-rounded tw-text-[10px] tw-font-medium ${statusColor(row.status)}`}>
                                            {row.status}
                                        </span>
                                    </td>
                                    <td className="tw-px-3 tw-py-2 tw-text-center">
                                        <button
                                            onClick={() => goToDetail(row.share_certificate_id || row.id)}
                                            className="tw-p-1.5 tw-rounded hover:tw-bg-blue-50 tw-text-gray-400 hover:tw-text-blue-600"
                                            title="View"
                                        >
                                            <Icon icon="mdi:eye-outline" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {!list?.loading && pagination && pagination.totalPages > 1 && (
                <div className="tw-flex tw-justify-center tw-gap-2">
                    <button
                        onClick={() => setPage(p => Math.max(1, p - 1))}
                        disabled={page === 1}
                        className="tw-px-3 tw-py-1.5 tw-text-sm tw-border tw-border-gray-200 tw-rounded-md disabled:tw-opacity-50"
                    >
                        Previous
                    </button>
                    <span className="tw-px-3 tw-py-1.5 tw-text-sm">
                        Page {pagination.page} of {pagination.totalPages}
                    </span>
                    <button
                        onClick={() => setPage(p => Math.min(pagination.totalPages, p + 1))}
                        disabled={page === pagination.totalPages}
                        className="tw-px-3 tw-py-1.5 tw-text-sm tw-border tw-border-gray-200 tw-rounded-md disabled:tw-opacity-50"
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default ShareCertificates;
